/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { useAlert } from '../../../Common/hooks';
import { getRequiredFieldsFilters } from '../../selectors';
import { getRequiredFieldsReports } from '../../services';
import { requiredFieldsError } from '../../constants';

const useRequiredFieldsReport = () => {
  const filters = useSelector(getRequiredFieldsFilters);
  const { showAlert } = useAlert();
  const [requiredFieldsReports, setRequiredFieldsReports] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const handleFilterChange = async () => {
    if (filters.aggregatorID && filters.payerID) {
      setIsLoading(true);
      const { requiredFields, status } = await getRequiredFieldsReports(filters);
      if (status === 404) {
        showAlert({ color: 'error', icon: 'exclamation', message: requiredFieldsError });
      }

      setRequiredFieldsReports(requiredFields);
      setIsLoading(false);
    } else {
      setRequiredFieldsReports([]);
    }
  };

  useEffect(() => {
    handleFilterChange();
  }, [filters]);

  return {
    requiredFieldsReports,
    isLoading,
  };
};

export default useRequiredFieldsReport;
